import SelectMenu from "../../../controls/SelectMenu";
import FinanceProductFilters from "./FinanceProductFilters";
import type {
  FinanceProductFilterOptions,
  FinanceReportFilters,
  ReportFilterOption,
  SetFinanceReportFilters,
} from "./types";

type Props = FinanceProductFilterOptions & {
  filters: FinanceReportFilters;
  setFilters: SetFinanceReportFilters;
  customers: ReportFilterOption[];
};

export default function CustomerProfitabilityFilters({
  filters,
  setFilters,
  customers,
  products,
  classes,
  categories,
}: Props) {
  const update = (key: "customer", value: ReportFilterOption) =>
    setFilters({ ...filters, [key]: value });

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      <SelectMenu
        title="Customer"
        name="customer"
        options={customers}
        value={filters.customer}
        handleInputChange={(event: { target: { value: ReportFilterOption } }) =>
          update("customer", event.target.value)
        }
      />
      <FinanceProductFilters
        filters={filters}
        setFilters={setFilters}
        classes={classes}
        categories={categories}
        products={products}
      />
    </div>
  );
}
